import http from '../../services/http';
import forResponse from '../../utils/forResponse';
import { STATUS_URL, GET_ACTIVE_CAMPAIGN, MODALS_DATA_URL, TEMPTED_STATUS_URL } from '../../constants/apiUrls/apiUrls';


export const checkStatus = () => forResponse(http.get(STATUS_URL));
export const checkStatusTempted = () => forResponse(http.get(TEMPTED_STATUS_URL));

export const getActiveCampaign = () => forResponse(http.get(GET_ACTIVE_CAMPAIGN));

export const getAnchorPortalCampaign = () => forResponse(http.get(GET_ACTIVE_CAMPAIGN, { params: { anchorPortal: true } }));

export const getModalsData = () => forResponse(http.get(MODALS_DATA_URL));

export const initializeGlobalSession = (user, rootStore) => new Promise(async(resolve, reject) => {
  if (!user.features.includes('ANCHOR_PORTAL')) {
    resolve();
  } else {
    try {
      await rootStore.privateMessagingStore.createGlobalPresenceSession(user.authenticated, user.user);
    } catch (e) {
      console.error('Could not create createGlobalPresenceSession', e);
      reject();
    }
    if (
      user.authenticated &&
        user.user
    ) {
      try {
        await rootStore.privateMessagingStore.addMeToGlobalPresence();
        rootStore.privateMessagingStore.attachGlobalEventsListener();
      } catch (e) {
        console.error('Could not attachGlobalEventsListener', e);
        reject();

      }
    }
    try {
      rootStore.privateMessagingStore.attachSystemEventsListener();
      resolve();
    } catch (e) {
      reject(e);
    }
  }
});
